module.exports = __webpack_public_path__ + "img/electric_enabled_selected.292fbcf6.svg";